require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.4@core-js/library/modules/es7.symbol.async-iterator.js
// module id = 99
// module chunks = 0